//#region src/core/ui/transition.ts
/** Shared data attributes for open/close transition state. Spread into component data-attrs objects. */
const TransitionDataAttrs = {
	/** Present during the open transition. */
	transitionStarting: "data-starting-style",
	/** Present during the close transition. */
	transitionEnding: "data-ending-style"
};
function getTransitionFlags(status) {
	return {
		transitionStarting: status === "starting",
		transitionEnding: status === "ending"
	};
}
function getTransitionStyleAttrs({ transitionStarting, transitionEnding }) {
	return {
		[TransitionDataAttrs.transitionStarting]: transitionStarting ? "" : void 0,
		[TransitionDataAttrs.transitionEnding]: transitionEnding ? "" : void 0
	};
}
//#endregion
export { TransitionDataAttrs, getTransitionFlags, getTransitionStyleAttrs };

//# sourceMappingURL=transition.js.map